import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-marketing-kpi',
  templateUrl: './marketing-kpi.component.html',
  styleUrls: ['./marketing-kpi.component.css']
})
export class MarketingKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  mktKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi: boolean = false;
  manfMonthFilterKpi: monthFilter;

  Highcharts = Highcharts;

  totalDataSO: any;
  totalDataKpiChartOptionsSO: Highcharts.Options;
  panelWiseDataSO: any;
  panelWiseKpiChartOptionsSO: Highcharts.Options;

  totalDataHOM: any;
  totalDataKpiChartOptionsHOM: Highcharts.Options;
  panelWiseDataHOM: any;
  panelWiseKpiChartOptionsHOM: Highcharts.Options;

  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-1', this.isManfMonthFilterSelectedKpi ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi) {
      this._dataService.setCookie('s-manfmonth-val-kpi-1', this.manfMonthFilterKpi.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-1');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-1');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi == null) {
      this.manfMonthFilterKpi = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpmktKpi: Array<UiFunctionalKPI> = [];

    let _totalQtySO: number = 0;
    let _delayQtySO: number = 0;
    let _onTimeQtySO: number = 0;
    let _delayQtySOZS1: number = 0;
    let _onTimeQtySOZS1: number = 0;
    let _delayQtySOZS1DBB: number = 0;
    let _onTimeQtySOZS1DBB: number = 0;
    let _delayQtySOZS2: number = 0;
    let _onTimeQtySOZS2: number = 0;
    let _delayQtySOZS9: number = 0;
    let _onTimeQtySOZS9: number = 0;
    let _delayQtySOZN1: number = 0;
    let _onTimeQtySOZN1: number = 0;

    let _totalQtyHOM: number = 0;
    let _delayQtyHOM: number = 0;
    let _onTimeQtyHOM: number = 0;
    let _delayQtyHOMZS1: number = 0;
    let _onTimeQtyHOMZS1: number = 0;
    let _delayQtyHOMZS1DBB: number = 0;
    let _onTimeQtyHOMZS1DBB: number = 0;
    let _delayQtyHOMZS2: number = 0;
    let _onTimeQtyHOMZS2: number = 0;
    let _delayQtyHOMZS9: number = 0;
    let _onTimeQtyHOMZS9: number = 0;
    let _delayQtyHOMZN1: number = 0;
    let _onTimeQtyHOMZN1: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            // Check for SO RELEASE planned and Actual Dates     
          
            

            if (_tmpSO.marketingIP.soReleaseDatePlanned != null && _tmpSO.marketingIP.soReleaseDateActual != null) {
            // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtySO += temp;
                }
              }
            });

              let _soPlanned = _tmpSO.marketingIP.soReleaseDatePlanned.getTime();
              let _soActual = _tmpSO.marketingIP.soReleaseDateActual.getTime();
              let _soDiff_time = _soPlanned - _soActual;
              let _soDiff = _soDiff_time / (1000 * 3600 * 24);

              // SO Delay
              if (_soDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtySO += temp;
                    }
                  }
                });

                let _individualDelayQtySO = 0; 
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySOZS1 += temp;
                          _individualDelayQtySO += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySOZS1DBB += temp;
                          _individualDelayQtySO += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySOZS2 += temp;
                          _individualDelayQtySO += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySOZN1 += temp;
                          _individualDelayQtySO += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySOZS9 += temp;
                          _individualDelayQtySO += temp;
                        }
                      }
                    });
                    break;
                }
                 /// FOR Excel Qty
                //  switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                //   case "001":
                //      _individualDelayQtySO = _delayQtySOZS1;
                //     break;
                //   case "002":
                //      _individualDelayQtySO = _delayQtySOZS1DBB;
                //     break;
                //   case "003":
                //      _individualDelayQtySO = _delayQtySOZS2; 
                //     break;
                //   case "004":
                //      _individualDelayQtySO = _delayQtySOZN1; 
                //     break;
                //   case "005":
                //      _individualDelayQtySO = _delayQtySOZS9; 
                //     break;
                // }
             

                

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'SO Release', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtySO, _tmpSO.marketingIP.soReleaseDatePlanned, null, null, _tmpSO.marketingIP.soReleaseDateActual, _soDiff,_tmpSO.marketingIP.soReleaseActualToken.addNotes)
                _tmpmktKpi.push(_tmpSSOobj);
              }
              // SO on Time
              if (_soDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtySO += temp;
                    }
                  }
                });

                let _individualOnTimeQtySO = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySOZS1 += temp;
                          _individualOnTimeQtySO += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySOZS1DBB += temp;
                          _individualOnTimeQtySO += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySOZS2 += temp;
                          _individualOnTimeQtySO += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySOZN1 += temp;
                          _individualOnTimeQtySO += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySOZS9 += temp;
                          _individualOnTimeQtySO += temp;
                        }
                      }
                    });
                    break;
                }

                /// FOR Excel Qty
                // switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                //   case "001":
                //      _individualOnTimeQtySO = _onTimeQtySOZS1;
                //     break;
                //   case "002":
                //      _individualOnTimeQtySO = _onTimeQtySOZS1DBB;
                //     break;
                //   case "003":
                //      _individualOnTimeQtySO = _onTimeQtySOZS2; 
                //     break;
                //   case "004":
                //      _individualOnTimeQtySO = _onTimeQtySOZN1; 
                //     break;
                //   case "005":
                //      _individualOnTimeQtySO = _onTimeQtySOZS9; 
                //     break;
                // }


                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'SO Release', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtySO, _tmpSO.marketingIP.soReleaseDatePlanned, null, null, _tmpSO.marketingIP.soReleaseDateActual, _soDiff,_tmpSO.marketingIP.soReleaseActualToken.addNotes)

                _tmpmktKpi.push(_tmpSSOobj);
              }


            }

            ////////////////////////// Check for HOM planned and Actual Dates      

            if (_tmpSO.marketingIP.plannedOverHandingDate != null && _tmpSO.marketingIP.actualHandingOverDate != null) {
            // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyHOM += temp;
                }
              }
            });

              let _homPlanned = _tmpSO.marketingIP.plannedOverHandingDate.getTime();
              let _homActual = _tmpSO.marketingIP.actualHandingOverDate.getTime();
              let _homDiff_time = _homPlanned - _homActual;
              let _homDiff = _homDiff_time / (1000 * 3600 * 24);

              // HOM Delay
              if (_homDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyHOM += temp;
                    }
                  }
                });

                let _individualDelayQtyHOM = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyHOMZS1 += temp;
                          _individualDelayQtyHOM += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyHOMZS1DBB += temp;
                          _individualDelayQtyHOM += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyHOMZS2 += temp;
                          _individualDelayQtyHOM += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyHOMZN1 += temp;
                          _individualDelayQtyHOM += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyHOMZS9 += temp;
                          _individualDelayQtyHOM += temp;
                        }
                      }
                    });
                    break;
                }

                /// FOR Excel Qty
                // switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                //   case "001":
                //     _individualDelayQtyHOM = _delayQtyHOMZS1;
                //     break;
                //   case "002":
                //     _individualDelayQtyHOM = _delayQtyHOMZS1DBB;
                //     break;
                //   case "003":
                //     _individualDelayQtyHOM = _delayQtyHOMZS2; 
                //     break;
                //   case "004":
                //     _individualDelayQtyHOM = _delayQtyHOMZN1; 
                //     break;
                //   case "005":
                //     _individualDelayQtyHOM = _delayQtyHOMZS9; 
                //     break;
                // }

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'HOM', _tmpSO.marketingIP.customerName, _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                 _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyHOM, _tmpSO.marketingIP.plannedOverHandingDate, null, null, _tmpSO.marketingIP.actualHandingOverDate, _homDiff, _tmpSO.marketingIP.actualHandingOverToken.addNotes)

                _tmpmktKpi.push(_tmpSSOobj);
              }
              // HOM on Time
              if (_homDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyHOM += temp;
                    }
                  }
                });

                let _individualOnTimeQtyHOM = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyHOMZS1 += temp;
                          _individualOnTimeQtyHOM+=temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyHOMZS1DBB += temp;
                          _individualOnTimeQtyHOM+=temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyHOMZS2 += temp;
                          _individualOnTimeQtyHOM+=temp;

                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyHOMZN1 += temp;
                          _individualOnTimeQtyHOM+=temp;

                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyHOMZS9 += temp;
                          _individualOnTimeQtyHOM+=temp;

                        }
                      }
                    });
                    break;
                }
                /// FOR Excel Qty
                
                // switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                //   case "001":
                //     _individualOnTimeQtyHOM = _onTimeQtyHOMZS1;
                //     break;
                //   case "002":
                //     _individualOnTimeQtyHOM = _onTimeQtyHOMZS1DBB;
                //     break;
                //   case "003":
                //     _individualOnTimeQtyHOM = _onTimeQtyHOMZS2; 
                //     break;
                //   case "004":
                //     _individualOnTimeQtyHOM = _onTimeQtyHOMZN1; 
                //     break;
                //   case "005":
                //     _individualOnTimeQtyHOM = _onTimeQtyHOMZS9; 
                //     break;
                // }

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'HOM', _tmpSO.marketingIP.customerName, _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                 _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyHOM, _tmpSO.marketingIP.plannedOverHandingDate, null, null, _tmpSO.marketingIP.actualHandingOverDate, _homDiff, _tmpSO.marketingIP.actualHandingOverToken.addNotes)

                _tmpmktKpi.push(_tmpSSOobj);
              }


            }

          });

        }


      }

    }

    if (_totalQtySO != 0 || _onTimeQtySO != 0 || _delayQtySO != 0) {
      this.totalDataSO = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtySO,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtySO,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtySO,
        }]
      }

      ];
    }
    else { this.totalDataSO = null; }

    this.totalDataKpiChartOptionsSO = this._kpiCharServ.getTotalDataChartOptions(this.totalDataSO);

    if (_onTimeQtySOZN1 != 0 || _onTimeQtySOZS9 != 0 || _onTimeQtySOZS1 != 0 || _onTimeQtySOZS1DBB != 0 || _onTimeQtySOZS2 != 0
      || _delayQtySOZN1 != 0 || _delayQtySOZS9 != 0 || _delayQtySOZS1 != 0 || _delayQtySOZS1DBB != 0 || _delayQtySOZS2 != 0) {

      this.panelWiseDataSO = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtySOZN1, _onTimeQtySOZS9, _onTimeQtySOZS1, _onTimeQtySOZS1DBB, _onTimeQtySOZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtySOZN1, _delayQtySOZS9, _delayQtySOZS1, _delayQtySOZS1DBB, _delayQtySOZS2],
      }

      ];
    }
    else { this.panelWiseDataSO = null; }

    this.panelWiseKpiChartOptionsSO = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataSO);

    ////////////////////

    if (_totalQtyHOM != 0 || _onTimeQtyHOM != 0 || _delayQtyHOM != 0) {
      this.totalDataHOM = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyHOM,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyHOM,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyHOM,
        }]
      }

      ];
    }
    else { this.totalDataHOM = null; }

    this.totalDataKpiChartOptionsHOM = this._kpiCharServ.getTotalDataChartOptions(this.totalDataHOM);

    if (_onTimeQtyHOMZN1 != 0 || _onTimeQtyHOMZS9 != 0 || _onTimeQtyHOMZS1 != 0 || _onTimeQtyHOMZS1DBB != 0 || _onTimeQtyHOMZS2 != 0
      || _delayQtyHOMZN1 != 0 || _delayQtyHOMZS9 != 0 || _delayQtyHOMZS1 != 0 || _delayQtyHOMZS1DBB != 0 || _delayQtyHOMZS2 != 0) {

      this.panelWiseDataHOM = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyHOMZN1, _onTimeQtyHOMZS9, _onTimeQtyHOMZS1, _onTimeQtyHOMZS1DBB, _onTimeQtyHOMZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyHOMZN1, _delayQtyHOMZS9, _delayQtyHOMZS1, _delayQtyHOMZS1DBB, _delayQtyHOMZS2],
      }

      ];
    }
    else { this.panelWiseDataHOM = null; }

    this.panelWiseKpiChartOptionsHOM = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataHOM);

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.mktKpi = _tmpmktKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi) {
      return this.manfMonthFilterKpi.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi) {
      return this.manfMonthFilterKpi.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi == true && this.manfMonthFilterKpi != null) {
      if (this.manfMonthFilterKpi.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }

}
